import Course from "@/models/Course";
import LicenseUser from "@/models/LicenceUser";
import LicenceAmountChange from "@/models/LicenceAmountChange";

export default class License {
    constructor(raw = {}) {
        this.id = raw.id;
        this.course = new Course(raw.course);
        this.amountOpen = raw.amountOpen;
        this.amountSpent = raw.amountSpent;
        this.amountPlanned = raw.amountPlanned;
        this.companyId = raw.companyId;
        this.licenceUsers = raw.licenceUsers.map((date) => new LicenseUser(date));
        this.purchases = raw.purchases.map((date) => new LicenceAmountChange(date));
    }
}
